import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { checkValidResponse, logError } from '@cigna/chcp/shared/util';
import {
  RemittanceDetailsRequest,
  RemittanceRead,
} from '@cigna/chcp/claims/shared/util';

@Injectable({ providedIn: 'root' })
export class ClaimsDDARService {
  public SERVICE_CONSUMER_CODE = '1000';

  public claimsDDARApi: string;
  public markAsReadUnReadApi: string;
  public lambdaReadUnreadApi: string;

  constructor(
    private http: HttpClient,
    @Inject('secureApi') secureApi: string,
  ) {
    this.claimsDDARApi = `${secureApi}/report/v2/search/ddar`;
    this.markAsReadUnReadApi = `${secureApi}/report/v2/ddar/status`;
    this.lambdaReadUnreadApi = `${secureApi}/claims`;
  }

  getDDARDetails(payload: RemittanceDetailsRequest) {
    const param: any = { ...payload };
    param.consumerCode = this.SERVICE_CONSUMER_CODE;
    return this.http
      .get(`${this.claimsDDARApi}/1`, {
        params: param,
      })
      .pipe(
        map(checkValidResponse),
        map((res) => res),
        catchError(logError),
      );
  }
  markAsReadOld(payload: RemittanceRead) {
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.SERVICE_CONSUMER_CODE,
    );
    return this.http
      .put(`${this.markAsReadUnReadApi}`, payload, {
        params,
      })
      .pipe(map(checkValidResponse), catchError(logError));
  }

  markAsRead(payload: RemittanceRead, lobType: string) {
    const param = {
      trackingNo: payload.remittanceTrackingNumber,
      createDt: payload.creationDate,
    };
    const params: HttpParams = new HttpParams().set(
      'consumerCode',
      this.SERVICE_CONSUMER_CODE,
    );
    const lob = lobType.toLowerCase().includes('den') ? 'dent' : 'med';

    return this.http
      .put(
        `${this.lambdaReadUnreadApi}/${lob}/appendix/remittance/read-receipt`,
        param,
        {
          params,
        },
      )
      .pipe(map(checkValidResponse), catchError(logError));
  }

  markAsUnread(trackingNumber: string, lobType: string) {
    const params: HttpParams = new HttpParams()
      .set('consumerCode', this.SERVICE_CONSUMER_CODE)
      .set('trackingNo', trackingNumber);
    const lob = lobType.toLowerCase().includes('den') ? 'dent' : 'med';

    return this.http
      .delete(
        `${this.lambdaReadUnreadApi}/${lob}/appendix/remittance/read-receipt`,
        {
          params,
        },
      )
      .pipe(map(checkValidResponse), catchError(logError));
  }
}
